export default __webpack_public_path__ + "static/Calibre-Light-395f9d9bfcc0ae2ef5ffb3ddfcc80534.woff2";